document.addEventListener('DOMContentLoaded', () => {
  const lazySizes = require('lazysizes');
  lazySizes.init();
});
